import { planTypes } from '@/common/constants';
import { mapGetters, mapMutations } from 'vuex';
import Ready from '@/utils/ready';
import { logger } from '@/utils/log';

const CartReady = new Ready()

export default {
  computed: {
    ...mapGetters(['planMapFlat', 'getCurrentBasePlanInfo']),
    isLDKBase() {
      return this.getCurrentBasePlanInfo.planType === planTypes.VIDEO_SDK;
    },
  },
  methods: {
    ...mapMutations(['setPlanMapFlat', 'cartIsReady']),
    resetAudioPlanInfo() {
      if (this.isLDKBase) {
        logger.info('video sdk dont support coupon');
        this.setPlanMapFlat(this.planMapFlat.map(item => ({
          ...item,
          supportCoupon: false,
        })));
      }
    },
  },
  created() {
    if (!this.isLDKBase) return;
    if (this.cartIsReady) CartReady.solved();
    CartReady.ready(() => this.resetAudioPlanInfo());
  },
  watch: {
    cartIsReady(v) {
      if(v) {
        CartReady.solved();
      }
    },
  },
}
